<template>
  <div class="haizol-main" :class="$route.name==='boot-page-preview-contract' ? 'previewClass':''">
    <div ref="haizol-main-wrapper" :class="this.$route.meta.noNav ? 'haizol-main-wrapper-padding' :''" class="haizol-main-wrapper enable-scroll">
      <el-scrollbar
        ref="scrollbar"
        :wrapClass="`el-scrollbar-wrap ${ noBg }`"
      >
        <!-- 页面中的播报 -->
        <Broadcast v-show="broadcastShow" v-if="$route.meta.broadcast" @close="broadcastShow = false" />
        <keep-alive>
          <router-view class="default-main" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view class="default-main" v-if="!$route.meta.keepAlive"></router-view>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import Broadcast from '@/components/other/broadcast.vue';
import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event';

export default {
  data() {
    return {
      scrollbarInstance: null,  //滚动组件实例
      broadcastShow: true,
    }
  },
  components: {
    Broadcast,
  },
  computed: {
    noBg() {
      return !this.$route.meta.noBg ? '' : 'no-bg';
    }
  },
  mounted() {
    console.log(this.$route,'dldlld')
    this.scrollbarInstance = this.$refs.scrollbar;
    /**
     * 因为el-scrollbar等类似第三方滚动条在默认情况下改变容器尺寸后，都会出现滚动条长度等显示异常，
     * 所以，监听下(指该元素，非window)，宽高有变就就重新初始化 
    */
    this.scrollbarInstance && 
    addResizeListener(this.$refs['haizol-main-wrapper'], this.scrollbarInstance.update);
  },
  beforeDestroy() {
    this.scrollbarInstance && 
    removeResizeListener(this.$refs['haizol-main-wrapper'], this.scrollbarInstance.update);
  },
}
</script>

<style lang="scss" scoped>
.haizol-main {
  flex: 1;
  width: 0;
  // width: 100%;
  height: 100%;
  overflow: hidden;
  &-wrapper {
    // padding: 0 12px; //加到下边el-scrollbar的样式中去了
    height: 100%;
    // overflow: hidden;
    // display: flex;
    // flex-direction: column;
    .default-main {
      // 高度就预先设置下吧，看页面中很多都不允许滚动。。。
      // flex: 1;
      // margin-bottom: 12px;
      // height: 0;
      // background: #fff;
      // background-clip: content-box;
    }
    &.enable-scroll {
      /* overflow-y: auto; */
      .default-main {
        height: auto;
      }
    }
  }

  // 去掉el-scrollbar的默认横向滚动条
  ::v-deep .el-scrollbar {
    height: 100%;
    &-wrap {
      overflow-x: hidden;
      padding: 0 12px;
      .el-scrollbar__view {
        min-height: 100%;
        // min-width: 1233px;
        min-width: 966px;
        padding: 12px 0;
        box-sizing: border-box;
        background: #fff;
        background-clip: content-box;
      }
      &.no-bg {
        .el-scrollbar__view {
          background: none;
        }
      }
    }
  }

  // 针对不带左侧菜单的页面，取消默认padding
  .haizol-main-wrapper-padding {
    ::v-deep .el-scrollbar__view {
      padding: 0 !important;
    }
  }
}
.previewClass{
   ::v-deep .el-scrollbar {
    height: 100%;
    &-wrap {
      overflow-x: hidden;
      padding: 0;
    }
  }
}
</style>